import axios from "fetch-api/fetch-api";

export function shareApi() {
  return axios.post<{ uuid: string; }>("/share-shopping-cart-v3");
}

export function getShareShoppingCartApi(uuid: string) {
  return axios.get(`/get-shared-shopping-cart?uuid=${uuid}`);
}
